import axios from './dataSources/default';

import { config } from '../config/';

export function getPointOfSales() {
  const url = `${config.URLS.SOFOLOGY_API}/salesorderprocessing/pointofsale`;
  return axios.get(url).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/services/storeService.js